<div>
  <div class="d-flex">
    <h4 class="large-h ms-ml-08">{{ 'Steps' | translator }}</h4>
    <div class="d-flex flex-wrap">
      <ng-container *ngFor="let step of projectStatus">
          <ng-container *ngIf="(step.name == 'Evaluation' && evaluationEnabled) || step.name != 'Evaluation'; else noUrl">
            <span [routerLink]="step.link + projectId" class="pg-num" [ngClass]="step.cssClass">{{ step.name | translator }}</span>
          </ng-container>
          <ng-template #noUrl>
            <span class="pg-num noclick" [ngClass]="step.cssClass">{{ step.name | translator }}</span>
          </ng-template>
      </ng-container>
    </div>
  </div>
</div>
